import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import React from 'react'

import { reloadWindow } from 'helpers/window'

import enhanceMessage from './enhanceMessage'

function ErrorDialog({ dismissError, error }) {
    const { message, code } = error || {}
    const enhancedMessage = enhanceMessage(message, code)
    const errorMsg =
        enhancedMessage ===
        'Participant disconnected because of duplicate identity'
            ? "we see that you've joined from somewhere else so we've disconnected you from here."
            : enhancedMessage

    console.count('ErrorDialog Component')
    return (
        <Dialog
            open={error !== null}
            onClose={() => dismissError()}
            fullWidth={true}
            maxWidth="xs"
        >
            <DialogTitle>uh.oh</DialogTitle>
            <DialogContent>
                <DialogContentText>{errorMsg}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={reloadWindow} color="primary" autoFocus>
                    Refresh
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ErrorDialog
